import { splitUrl, within } from './collection-query.ts'

type TabStore = Pick<Storage, 'getItem' | 'setItem' | 'removeItem' | 'key' | 'length'>

const PREFIX = 'reconforta:list:'

function tabStore(): TabStore | null {
  try {
    return window.sessionStorage
  } catch {
    return null
  }
}

export function rememberList(
  url: string,
  store: TabStore | null = tabStore(),
  list = splitUrl(url).path,
): void {
  const { path, query } = splitUrl(url)

  try {
    store?.setItem(PREFIX + list, path + query)
  } catch {
    // Private mode or a full quota: a back link then lands on the bare list.
  }
}

export function rememberLocation(
  { pathname, search }: Pick<Location, 'pathname' | 'search'>,
  store: TabStore | null = tabStore(),
  list = pathname,
): void {
  rememberList(pathname + search, store, list)
}

export function listReturn(href: string, store: TabStore | null = tabStore()): string {
  const { path, query } = splitUrl(href)
  if (query !== '') return href

  let remembered: string | null = null
  try {
    remembered = store?.getItem(PREFIX + path) ?? null
  } catch {
    return href
  }

  return remembered !== null && within(splitUrl(remembered).path, path) ? remembered : href
}

export function forgetLists(store: TabStore | null = tabStore()): void {
  if (store === null) return

  try {
    const keys = Array.from({ length: store.length }, (_, index) => store.key(index))
    for (const key of keys) {
      if (key?.startsWith(PREFIX)) store.removeItem(key)
    }
  } catch {
    return
  }
}
